<template>
  <div>
    <div class="col-12 irregular-page-title">
      <PageHeader :page="page">
        <div class="d-flex justify-content-end h-100 align-items-end">
          <ActionButton
            text="Regresar"
            class="m-2"
            variant="outline-success"
            i="fas fa-arrow-circle-left"
            @click="$router.push('/humanres')"
          />
          <ActionButton
            v-if="canShowPrint && canQueueSaee10Report"
            text="Imprimir"
            class="m-2"
            variant="outline-success"
            i="fas fa-print"
            @click="handlePrint()"
          />
          <ActionButton
            v-if="showAddIrregularPeopleButton"
            class="m-2"
            text="Añadir"
            variant="outline-success"
            i="fas fa-file-plus"
            @click="goToAddRequest()"
          />
          <ActionButton
            v-if="canRequestResource"
            class="m-2"
            text="Solicitar Recurso"
            variant="success"
            i="fas fa-user-plus"
            @click="requestResource()"
          />
          <ActionButton
            v-if="showButtonChangeStatus"
            class="m-2"
            text="Cambiar Estatus"
            variant="success"
            i="fas fa-exchange-alt"
            @click="() => this.showContainerStatusChange = true"
          />
        </div>
      </PageHeader>
    </div>
    <queue-report-status
      v-if="queuedReportInfo"
      :report-info="queuedReportInfo"
      @onCancel="onCancelHandler"
      @onDownload="onDownloadHandler"
    />
    <ContainerStatusChange  
      v-if="this.showContainerStatusChange" 
      :filters="filtersTochangeStatus"
      :academicYearId="academicYear"      
      @close="closeContainerStatusChange()"
      @accept="updateMultiplesRequest"
    />
    <ul
      class="d-flex justify-content-between tab-list nav nav-pills mb-3 mt-4"
      role="tablist"
    >
      <li class="col-6 text-center py-2 tab-item">
        <a
          class="nav-link no-margin-left mt-1 py-2 tab-link"
          :class="{
            active: activeTab === tabs.NECESIDADES,
            'link-disabled': disabled
          }"
          href="#necesidades"
          role="tab"
          aria-selected="true"
          aria-controls="tab-i"
          @click="activeTab = tabs.NECESIDADES"
          >Necesidades de servicio o de apoyo al estudiante</a
        >
      </li>
      <li class="col-6 text-center py-2 tab-item">
        <a
          class="nav-link no-margin-left mt-1 py-2 tab-link"
          :class="{
            active: activeTab === tabs.SOLICITUDES,
            'link-disabled': disabled
          }"
          href="#solicitudes"
          role="tab"
          aria-selected="true"
          aria-controls="tab-i"
          @click="activeTab = tabs.SOLICITUDES"
          >Solicitudes de personal irregular</a
        >
      </li>
    </ul>
    <div v-if="activeTab === tabs.NECESIDADES">
      <IrregularNecesities
        :collections="necesitiesFilters"
        @validateIfNeedResource="changeValueToValidate"
        @changeAcademicYear="onChangeAcademicYear"
      />
    </div>
    <div v-if="activeTab === tabs.SOLICITUDES">
      <IrregularRequests 
        ref="irregularRequests"
        :collections="requestsFilters"        
        @changeStatusData="changeStatusByData" 
        @getListIds="getAllIds"
        @update="updateMultiplesRequest"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import ActionButton from "ActionButton";
import CustomModal from "@/components/common/CustomModal";
import IrregularNecesities from "./IrregularNecesities.vue";
import IrregularRequests from "./IrregularRequests.vue";
import QueueReportStatus from "@/views/pei/complianceRlv/components/QueueReportStatus.vue";
import ContainerStatusChange from "./components/ContainerStatusChange.vue";
import { requestStatusCodes } from "@/utils/constants/hrrequest/requestStatusCodes";
import { QueueReportStatuses } from "@/utils/constants/queue/queueReportStatuses";
import { QueueReportType } from "@/utils/constants/queue/queueReportType";
import {
  ValidateAssistantCertification,
  initFilters as _initFilters,
} from "@/modules/peiSAEE/api.js";
import reportService from '@/services/report';
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";
import { GetValidations } from "@/modules/peiSAEE/api.js";
import store from "@/store/index";
import mixAlert from "@/mixin/alert.mixin";
import {
  updateMultipleRequestStatus
} from "@/modules/human-resources/api";
import academicYears from "@/utils/constants/academicYears";
import hubService, { serverEvents } from "@/services/signalr/hubService";

const TABS = {
  NECESIDADES: 0,
  SOLICITUDES: 1
};

const TABS_HASHS = {
  NECESIDADES: "#necesidades",
  SOLICITUDES: "#solicitudes"
};
const KEY_CHECKBOX='CHECKBOXSTATUSSTORAGE'
export default {
  name: "IrregularStaffRequest",
  mixins: [mixAlert],
  components: {
    PageHeader,
    ActionButton,
    CustomModal,
    IrregularNecesities,
    IrregularRequests,
    ContainerStatusChange,
    QueueReportStatus,
  },
  data() {
    return {
      showContainerStatusChange:false,
      page: {
        icon: "fas fa-users-class py-1",
        title: "Solicitud de Personal Irregular",
        routes: ["Inicio", "Recursos Humanos", "Personal Irregular"]
      },
      filters: null,
      activeTab: null,
      disabled: false,
      showAddIrregularPeopleButton: false,
      tabs: TABS,
      necesitiesFilters: null,
      requestsFilters: null,
      filtersTochangeStatus:[],
      academicYear:null,
      schoolId:null,
      listId:[],
      showButtonChangeStatus: false,
      academicYearId: null,
      model:{
        statusId: null,
        previousStatusId: null,
        statusDescription:null,
        reason: null,
        authorizationNumber: null,
        dailyShiftId: null,
        recommendationTypeId: null,
        recommendsExisting: null,
        assistantId: null,
        requestIds:[],      
      },
      queuedReportInfo: null,
    };
  },
  created() {
    hubService.onEvent(serverEvents.ReceiveQueueReportMessage, this.updateQueuedReportInfo)
  },
  methods: {    
    closeContainerStatusChange(){      
     this.showContainerStatusChange=false 
    },    
    changeStatusByData(data){   
      this.academicYear = data.academicYear.id;
      this.schoolId = data.school?.id;              

      this.showButtonChangeStatus = this.academicYear >= academicYears.Y2023_2024 
               && store.getters.HasPermission("rrhh.changestatus.irregularperson");
    },
    changeValueToValidate(value) {
      this.filters = value;
    },
    async setAddIrregularPeopleButton() {
      this.showAddIrregularPeopleButton = false;

      const hasPermission = store.getters.HasPermission(
        "eduesp.hr.addirregularpeople"
      );
      if (hasPermission) {
        this.showAddIrregularPeopleButton = true;
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ["StartSchoolDate"],
        academicYearId
      });

      if (!sysParameters[0]?.staticValue) return;

      const dateToShow = new Date(sysParameters[0].staticValue);
      const currentDate = new Date();

      if (
        dateToShow.getUTCFullYear() != currentDate.getUTCFullYear() ||
        dateToShow.getUTCMonth() != currentDate.getUTCMonth() ||
        dateToShow.getUTCDate() != currentDate.getUTCDate()
      )
        return;

      this.showAddIrregularPeopleButton = true;
    },
    async checkCertifiedAssistants() {
      const schoolId = Number(this.schoolIdFromFilterOrUserProfile);
      if (!schoolId) return;

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await ValidateAssistantCertification(
        academicYearId,
        schoolId
      );
      if (data) return;

      // If not certified, show the message modal
      this.disabled = true;
      await mixAlert.methods.ShowAlertModal(
        "Atención",
        "Para acceder al manejo de las solicitudes es necesario que certifique el listado de asistentes de servicios."
      );
    },
    getAllIds(data){
      const existInList=this.listId.findIndex(item => item.id === data.id)>-1;

       if (!existInList && (data.selected || data.checkValue)) {
          this.listId.push({id:data.id,schoolId:data.schoolId}) 
        } else if (existInList && !data.selected) {
          this.listId = this.listId.filter(item => item.id !== data.id)
        }
    },
    async requestResource() {
      const mappedFilters = {
        academicYearId: Number(this.filters.academicYear.id),
        schoolId: this.schoolIdFromFilterOrUserProfile
      };
      const validSchoolId = mappedFilters.schoolId > 0;
      if (!validSchoolId) {
        this.ShowToast(
          "",
          "Favor de seleccionar una escuela.",
          "error"
        );
        return;
      }
      try {
        await GetValidations(mappedFilters, mappedFilters.schoolId);
        this.$router.push({ path: "/humanres/irregularstaffrequest/addstaff", query: mappedFilters });
      } catch (e) {
        const message = e.response?.data?.message || "Error al validar la escuela.";
        this.ShowToast(
          "",
         message,
          "error"
        );
      }
    },
    goToAddRequest(){     
       this.$router.push({ 
        path: '/humanres/request/add',       
        query: {
          newModule: 1            
        },
        })
    },
    onChangeAcademicYear(academicYearId){      
      this.academicYearId = academicYearId
    },
    async initFilters() {
      const { data } = await _initFilters();

      const { requestsStatus, ...necesities } = data; // Removing requests status for necesities
      const { necesitiesStatus, ...requests } = data; // Removing necesities status for requests

      this.necesitiesFilters = necesities;
      this.requestsFilters = requests;
      this.filtersTochangeStatus = this.requestsFilters.requestsStatus.filter(item => item.id == requestStatusCodes.recomended || item.id == requestStatusCodes.notRecomended);
    },
    async updateMultiplesRequest(data){
      
      if(this.listId.length == 0)
      {
        this.ShowToast(
            "Error",
            "Favor de seleccionar al menos una solicitud.",
            "error"
          );
        return;
      }

      if(data.status.id == requestStatusCodes.recomended)
      {
        const sameSchoolId = this.listId.every((obj, index, array) => {
          return obj.schoolId === array[0].schoolId;
        });

        if (!sameSchoolId) {        
          this.ShowToast(
            "Error",
            "Para recomendar las solicitudes deben pertenecer a la misma escuela.",
            "error"
          );
          return;
        }
      }     
      
      this.model.statusId=data.status.id
      this.model.statusDescription=data.status.name
      this.model.reason=data.reason;
      this.model.authorizationNumber = data.authorizationNumber;
      this.model.recommendsExisting = data.status.id == requestStatusCodes.recomended ? true : false;
      this.model.requestIds=this.listId.map(obj => obj.id);;
      this.model.previousStatusId=0
      await  updateMultipleRequestStatus(this.model)
      this.closeContainerStatusChange();
      
      this.ShowToast(
          'Alerta',
          'La Información ha sido guardada exitosamente.',
          'success'
      );

      this.$refs.irregularRequests.configurationResult();
      this.listId=[]
      sessionStorage.setItem( KEY_CHECKBOX, JSON.stringify([]));
    },
    async handlePrint() {
      const params = {
        academicYearId: this.academicYearId
      };

      await reportService.queueSaee10Report(params);  
      
      this.ShowToast(
        'Alerta',
        'Se ha completado su solicitud existosamente.',
        'success'
      );
    },
    async getCurrentQueuedReportStatus() {
      const { data } = await reportService.getUserQueuedReport(QueueReportType.SAEE10Report);
      this.updateQueuedReportInfo(data);
    },
    updateQueuedReportInfo(reportInfo) {
      this.queuedReportInfo = reportInfo;
    },
    async onDownloadHandler(executionLogId) {
      await reportService.downloadQueuedReport(executionLogId);
    },

    async onCancelHandler(executionLogId) {
      await reportService.cancelQueuedReport(executionLogId)
      this.updateQueuedReportInfo(null);
    },
  },
  computed:{    
    canShowPrint() {
      return this.activeTab == this.tabs.NECESIDADES;
    },
    schoolIdFromFilterOrUserProfile() {
      return this.filters?.school?.id ?? this.userProfile?.schoolid;
    },
    isNecessityTab() {
      return this.activeTab === this.tabs.NECESIDADES;
    },
    canRequestResource() {
      return this.isNecessityTab && store.getters.HasPermission("rrhh.necessitytab.requestresourcebutton.view");
    },
    canQueueSaee10Report() {
      return this.queuedReportInfo == null
        || this.queuedReportInfo.statusId === QueueReportStatuses.Failed
        || this.queuedReportInfo.statusId === QueueReportStatuses.Completed;
    },
  },
  async mounted() {
    this.setAddIrregularPeopleButton();
    this.checkCertifiedAssistants();
    await this.initFilters();
    await this.getCurrentQueuedReportStatus();
    sessionStorage.setItem( KEY_CHECKBOX, JSON.stringify([]));
    if (this.$route.hash == TABS_HASHS.SOLICITUDES)
      this.activeTab = this.tabs.SOLICITUDES;
    else if (this.$route.hash == TABS_HASHS.NECESIDADES)
      this.activeTab = this.tabs.NECESIDADES;
  },
  destroyed() {
    sessionStorage.setItem(KEY_CHECKBOX, JSON.stringify([]));
  }
};
</script>

<style scoped>
.link-disabled {
  pointer-events: none;
}

.tab-link {
  height: 40px !important;
  background-color: #fff;
}
</style>

<style>
/* Not scoped by design */
.nav-text {
  font-weight: bold !important;
}

.tab-item {
  background: #f2f2f2 0% 0% no-repeat padding-box;
}
</style>
